// Search.js
import React from 'react';
import { Link } from 'react-router-dom';
import Chatbot from '../components/Chatbot';

const Search = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built. Check back again later.<br /> You may still test our Chatbot Beta though!<br />Click on Deliveranz below!</p>
      <Link to="/">Go back to Home</Link>
      <Chatbot />
    </div>
  );
};

export default Search;
